import uuid from 'uuid';

import { Placement, ToastLevel, ToastType } from '@philips-emr/tws-constants';
import { MessageService, ToastService as TS } from '@philips-emr/tws-core/lib/services';
import { HttpStatus, RequestResponse } from '@philips-emr/tws-core/lib/services/http-service';

interface Toast {
  message: string;
  level: ToastLevel;
}

class ToastService {

  private static toasHistory: [string?] = [];

  static open(arg: RequestResponse | Toast): void {

    const id = `tws-toast-service-${uuid()}`;
    let message;
    let level;

    if (this.isRequestResponse(arg)) {

      if (this.isException(arg.body)) {
        const exception = arg.body as Toast;
        message = exception.message;
      } else {
        message = arg.body || MessageService.translate('provider.general-error');

        if (typeof message === 'object') {
          message = Object.values(message).shift() as string;
        }

      }

      switch (arg.status) {
        case HttpStatus.OK:
        case HttpStatus.CREATED:
          level = ToastLevel.SUCCESS;
          message = MessageService.translate('provider.request-sucessfull');
          break;
        case HttpStatus.BAD_REQUEST:
        case HttpStatus.UNAUTHORIZED:
        case 500:
        case 404:
          level = ToastLevel.ERROR;
          break;
        default:
          level = ToastLevel.CAUTION;
      }
    } else {
      message = arg.message;
      level = arg.level;
    }

    TS.open({
      id,
      dismissible: true,
      placement: Placement.TOP,
      type: ToastType.BUBBLE,
      showIcon: true,
      highlight: false,
      message,
      title: 'provider.warning',
      timeout: 7500,
      level,
    });

    if (this.toasHistory.length > 1) {
      TS.close(this.toasHistory.shift() ?? '');
    }

    this.toasHistory.push(id);
  }

  private static isRequestResponse(object: any): object is RequestResponse {
    return Object.prototype.hasOwnProperty.call(object, 'body');
  }

  private static isException(object: any): boolean {
    return Object.prototype.hasOwnProperty.call(object, 'code');

  }
}

export {
  ToastService,
};
